import bcrypt from 'bcryptjs';

/**
 * パスワードをハッシュ化する
 * @param {string} password - 平文のパスワード
 * @returns {Promise<string>} ハッシュ化されたパスワード
 */
export const hashPassword = async (password) => {
  try {
    const saltRounds = 10;
    const hashedPassword = await bcrypt.hash(password, saltRounds);
    return hashedPassword;
  } catch (error) {
    console.error('パスワードのハッシュ化に失敗しました:', error);
    throw new Error('パスワードの暗号化に失敗しました');
  }
};

/**
 * パスワードを検証する
 * @param {string} password - 平文のパスワード
 * @param {string} hashedPassword - ハッシュ化されたパスワード
 * @returns {Promise<boolean>} パスワードが一致するかどうか
 */
export const verifyPassword = async (password, hashedPassword) => {
  try {
    const isMatch = await bcrypt.compare(password, hashedPassword);
    return isMatch;
  } catch (error) {
    console.error('パスワードの検証に失敗しました:', error);
    return false;
  }
};

/**
 * パスワードがハッシュ化されているかチェックする
 * bcryptのハッシュは$2a$または$2b$で始まる
 * @param {string} password - チェックするパスワード
 * @returns {boolean} ハッシュ化されているかどうか
 */
export const isPasswordHashed = (password) => {
  if (!password || typeof password !== 'string') {
    return false;
  }
  return password.startsWith('$2a$') || password.startsWith('$2b$');
}; 